<template>
  <div class="resource__meta">
    <ul class="icon-list">
      <li
        v-if="states"
        aria-label="States and Territories this resource relates to"
        class="states"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-solid:location-dot" />
        </i>
        <span>
          {{ listedStates }}
        </span>
      </li>
      <li v-if="resourceType" aria-label="Type of Resource" class="type">
        <i class="icon icon--lg">
          <Icon name="fa6-regular:file" />
        </i>
        <span>
          {{ resourceType }}
        </span>
      </li>
      <li v-if="organisation">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:arrow-up-right-from-square" />
        </i>
        <span v-if="url">
          <a
            :href="url"
            aria-label="Organisation related to this Resource - opens in new tab"
            class="resource__meta-link"
            rel="external"
            target="_blank"
          >
            {{ organisation }}
          </a>
        </span>
        <span v-else>
          {{ organisation }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { ResourcesMetaProps } from './types'

const props = defineProps<ResourcesMetaProps>()
const listedStates = computed(() => props.states && props.states.join(', '))
const url = computed(() => props.link?.url || '')
</script>

<style lang="less" scoped>
.resource__meta {
  .rounded-sm();

  background: @color-fill-normal;
  padding: 0 @gutter-sm;
  max-width: @375px;

  ul {
    li {
      &.states {
        span {
          .uppercase();
        }
      }

      &.type {
        span {
          .capitalize();
        }
      }
    }
  }
}
</style>
